import { HECTO } from './metricPrefixes'

export const PALLET_LENGTH = 1.2
export const PALLET_LENGTH_IN_CENTIMETER = PALLET_LENGTH * HECTO

export const PALLET_MIN_WIDTH = 0.8
export const PALLET_MAX_WIDTH = 1.2
export const PALLET_MIN_WIDTH_IN_CENTIMETER = PALLET_MIN_WIDTH * HECTO
export const PALLET_MAX_WIDTH_IN_CENTIMETER = PALLET_MAX_WIDTH * HECTO
